import React from 'react';
import {NavLink} from "react-router-dom";

const ApartmentItem = (props) => {
    return (
        <div className="col-12 col-md-6 col-xl-4">
            <div className="single-featured-property mb-50 wow fadeInUp" data-wow-delay="100ms">

                <div className="property-thumb item-image">
                    <NavLink to={'/view/apartment/' + props.data.apartment_uuid}>
                        <img src={props.data.images_url[0]} alt="image apartment"/>
                    </NavLink>
                    <div className="tag">
                        <span>For Rent</span>
                    </div>
                    <div className="list-price">
                        <p>${props.data.price_per_month}</p>
                    </div>
                </div>

                <div className="property-content">
                    <h5>{props.data.title}</h5>
                    <p className="fa fa-map-marker location"><img src="img/icons/location.png" alt=""/>
                        {props.data.address.country}, {props.data.address.city}
                    </p>
                    <p>{props.data.description}</p>
                    <div className="property-meta-data d-flex align-items-end justify-content-between">
                        <div className="new-tag">
                            <img className="fa fa-users" src="img/icons/new.png" alt=""/>
                        </div>
                        <div className="bathroom">
                            <img src="img/icons/bathtub.png" alt=""/>
                            <span>2</span>
                        </div>
                        <div className="garage">
                            <img src="img/icons/garage.png" alt=""/>
                            <span>2</span>
                        </div>
                        <div className="space">
                            <img src="img/icons/space.png" alt=""/>
                            <span>120 sq ft</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default ApartmentItem;